import { apiClient } from '../../common/ApiClient';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { DataObjectCommentDto } from '../schema';
import { expand } from 'uri-template-lite';
import { DataObjectVersionUrl } from './DataObjectVersionUrls';
import { DataObjectVersionSourceSchema } from '../schema/DataObjectVersionSchema';

const getDataObjectVersionSources = (versionId: number) =>
  apiClient
    .get<DataObjectCommentDto>(
      expand(DataObjectVersionUrl.SOURCES, { id: versionId }),
    )
    .then((response) =>
      DataObjectVersionSourceSchema.array().parse(response.data),
    );

export const useDataObjectVersionSourcesQuery = createApiQueryHook(
  ['dataObjectVersionSources'],
  getDataObjectVersionSources,
);
